module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('core-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('dashboard-header', {
    attrs: {
      "showMode": _vm.showMode,
      "isActivePay": _vm.user.active_pay
    },
    on: {
      "toggleShowMode": _vm.toggleShowMode
    }
  }), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "ql-dashboard-top"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.mostRecentProject || _vm.userPendingInvites.length > 0) ? _c('md-layout', {
    attrs: {
      "md-row": "",
      "md-flex": "60"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-row": ""
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-accent btn-start-project",
    on: {
      "click": function($event) {
        _vm.openCreateProject()
      }
    }
  }, [_vm._v("Start a New Project")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-row": "",
      "md-gutter": "16",
      "md-align": "center"
    }
  }, [(_vm.mostRecentProject) ? _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('dashboard-project-box', {
    attrs: {
      "project": _vm.mostRecentProject
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostRecentProject || _vm.userPendingInvites.length > 0) ? _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('dashboard-pending-projects', {
    attrs: {
      "projects": _vm.userPendingInvites,
      "user": _vm.user
    }
  })], 1) : _vm._e()], 1)], 1) : _c('md-layout', {
    attrs: {
      "md-row": "",
      "md-vertical-align": "center",
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-row": ""
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-accent btn-start-project",
    on: {
      "click": function($event) {
        _vm.openCreateProject()
      }
    }
  }, [_vm._v("Start your first Project")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.displayProjects.length) ? _c('md-layout', {
    attrs: {
      "md-row": "",
      "md-flex": "40"
    }
  }, [_c('dashboard-project-grid', {
    attrs: {
      "projects": _vm.displayProjects
    }
  })], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "dashboard"
  }, [_c('md-layout', {
    attrs: {
      "md-row": "",
      "md-flex": "100",
      "md-vertical-align": "center",
      "md-align": "center"
    }
  }, [_c('span', {
    staticClass: "md-subheader"
  }, [_vm._v("Loading your projects...")])])], 1), _vm._v(" "), _c('create-project', {
    ref: "createProject"
  }), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c6e50ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/views/dashboard.vue
// module id = 666
// module chunks = 2